import templateUrl from "emun.order/order-change-writingrep-prompt.htm";
import open from "webmodals/open";
import modals from "webmodals/modals";
import ServiceBus from 'servicestack/service-bus'
import basicController from "servicestack/basic.controller.properties";

class controller {
  constructor($scope, options) {
    const $ctrl = this;
	basicController($ctrl);
	$ctrl.bus = $ctrl.$session.bus;
    $ctrl.title = options.title || " Change Writing Rep...";
    $ctrl.order = options.order || {};
	$ctrl.request = {
		cartId: $ctrl.order.id,
		writingRepId: ""
	};
    $ctrl.submit = () => {
		$ctrl.bus.send("ChangeWritingRep.json", $ctrl.request).then(res => {
			$ctrl.$close({ updated: res.data });
		});
    };
  }
  findReps(val) {
    let $ctrl = this;
    let url = `QuerySalesReps.json?Take=15&JsConfig=ExcludeDefaultValues&Search=${val}&OrderBy=Id`; //
    return $ctrl.bus.send(url).then(res => res.data.results);
  }
  setRep(rep) {
    const $ctrl = this;
    if (!rep) rep = {};
    $ctrl.request.writingRepId = rep.id;
  }

}

export default {
  open(options) {
    return modals.open(
      Object.assign(
        {
          templateUrl,
          resolve: {
            options: () => options
          },
          bindToController: true,
          controller,
          controllerAs: "$ctrl",
          size: "md"
        },
        (options || {}).modal
      )
    ).result;
  }
};

